"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.cleanTitle = void 0;
exports.createPageTitle = createPageTitle;
exports.describeListing = describeListing;
exports.describeSearch = describeSearch;
exports.extractTypeSlug = extractTypeSlug;
exports.filterListing = filterListing;
exports.getDisclaimers = getDisclaimers;
exports.getListingBreadcrumbs = getListingBreadcrumbs;
exports.getListingUrl = getListingUrl;
exports.getQueryBreadcrumbs = getQueryBreadcrumbs;
exports.getStructuredData = void 0;
exports.getTypeSlug = getTypeSlug;
exports.hasValidMembers = void 0;
exports.isElite = isElite;
exports.isSellable = isSellable;
exports.listingLinkMeta = listingLinkMeta;
exports.listingsToPoints = void 0;
exports.prepareQuery = prepareQuery;
var _freeze = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/freeze"));
var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/is-array"));
var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _string = require("@raywhite/helpers-utils/lib/helpers/string");
var _structuredData = require("@raywhite/helpers-utils/lib/helpers/structuredData");
var _time = require("@raywhite/helpers-utils/lib/helpers/time");
var _sanitization = require("@raywhite/helpers-utils/lib/helpers/sanitization");
var _link = require("@raywhite/helpers-utils/lib/helpers/link");
var _agent = require("../member/agent");
var _utils = require("./utils");
var _formatting = require("./formatting");
var _codes = require("./codes");
var _context5;
/*
 * property types
 *
 * ALP agistment
 * BUS business (subType ignored)
 * CLR clearing-sale
 * COM
 *    - commercial-for-sale (subType BOTH, SAL)
 *    - commercial-for-lease (subType BOTH, LSE)
 * HOL holiday
 * LVS livestock
 * LVW livestock-wanted
 * REN for-rent
 * RUR rural
 * SAL for-sale
 *
 * status
 * CUR (default, applies to all above)
 * LSE
 *    - commercial-leased (COM, LSE)
 *    - leased (REN, LSE)
 * SLD
 *    - commercial-sold (COM, SLD)
 *    - sold (SAL, SLD)
 */
var slugMap = (0, _freeze.default)({
  '': ['CUR', null, null],
  agistment: ['CUR', 'ALP', null],
  business: ['CUR', 'BUS', null],
  'clearing-sale': ['CUR', 'CLR', null],
  'commercial-for-lease': ['CUR', 'COM', ['LSE', 'BOTH']],
  'commercial-for-sale': ['CUR', 'COM', ['SAL', 'BOTH']],
  commercial: ['CUR', 'COM', null],
  holiday: ['CUR', 'HOL', null],
  'leased-holiday': ['LSE', 'HOL', null],
  livestock: ['CUR', 'LVS', null],
  'livestock-wanted': ['CUR', 'LVW', null],
  'for-rent': ['CUR', ['REN', 'HOL', 'COM'], null, ['SAL']],
  'residential-for-rent': ['CUR', 'REN', null],
  rural: ['CUR', 'RUR', null],
  'for-sale': ['CUR', ['SAL', 'ALP', 'COM', 'BUS', 'RUR'], null, ['LSE']],
  'residential-for-sale': ['CUR', 'SAL', null],
  sold: ['SLD', null, null],
  leased: ['LSE', null, null],
  'recent-transactions': [['SLD', 'LSE'], null, null],
  transactions: [['SLD', 'LSE'], null, null],
  'leased-residential': ['LSE', 'REN', null],
  'leased-commercial': ['LSE', 'COM', null],
  'sold-residential': ['SLD', 'SAL', null],
  'sold-commercial': ['SLD', 'COM', null],
  'sold-rural': ['SLD', 'RUR', null],
  'sold-business': ['SLD', 'BUS', null],
  'sold-livestock': ['SLD', 'LVS', null],
  investment: ['CUR', null, null, null, {
    tenantedPercent: {
      gte: 1
    },
    _formKey: 'CUR_COM'
  }],
  'sold-investment': ['SLD', null, null, null, {
    tenantedPercent: {
      gte: 1
    },
    _formKey: 'SLD_COM'
  }]
});
function isSellable(typeCode, subTypeCode) {
  var _context;
  if ((0, _indexOf.default)(_context = ['SAL', 'BUS', 'RUR', 'LVS']).call(_context, typeCode) !== -1) {
    return true;
  }
  return typeCode === 'COM' && subTypeCode !== 'LSE';
}
function condenseArgs(status, type, subTypeCode, notSubTypeCode) {
  var _context2, _context3, _context4;
  return (0, _concat.default)(_context2 = (0, _concat.default)(_context3 = (0, _concat.default)(_context4 = "".concat(status, "_")).call(_context4, type, "_")).call(_context3, subTypeCode, "_")).call(_context2, notSubTypeCode);
}

// Build arg mapping by reversing the slug map; ignores multiple subType records
// and adds them manually.
var argMap = (0, _reduce.default)(_context5 = (0, _keys.default)(slugMap)).call(_context5, (result, slug) => {
  var [status, type, subTypeCode, notSubTypeCode, custom] = slugMap[slug];

  // Ignore custom queries or multiple sub type codes, no use for reverse mapping
  if (custom || (0, _isArray.default)(subTypeCode)) {
    return result;
  }
  result[condenseArgs(status, type, subTypeCode, notSubTypeCode)] = slug;
  return result;
}, {});
argMap[condenseArgs('CUR', 'COM', 'BOTH')] = 'commercial';
argMap[condenseArgs('CUR', 'COM', 'SAL')] = 'commercial-for-sale';
argMap[condenseArgs('CUR', 'COM', 'LSE')] = 'commercial-for-lease';
function getTypeSlug(status, type, subTypeCode) {
  var typed = argMap[condenseArgs(status, type, subTypeCode)] || argMap[condenseArgs(status, type, null)] || argMap[condenseArgs(status, null, null)];
  if (typed) return typed;
  return argMap[condenseArgs(status, null, subTypeCode)];
}
function extractTypeSlug(slug) {
  var mapped = slugMap[(slug || '').toLowerCase()];
  var [statusCode, typeCode, subTypeCode, notSubTypeCode, custom = {}] = mapped || [];
  return {
    statusCode,
    typeCode,
    subTypeCode,
    notSubTypeCode,
    isValid: !!mapped,
    custom
  };
}
function extractSuburbParts(suburb) {
  var _context6;
  if (!/^[a-z-]+-\d+$/.test(suburb)) {
    return {
      suburb,
      postCode: null
    };
  }
  var parts = (0, _slice.default)(_context6 = /([a-z-]+)-(\d+)/.exec(suburb)).call(_context6, 1, 3);
  return {
    suburb: parts[0],
    postCode: parts[1]
  };
}
function getListingUrl(listing) {
  var _context7, _context8;
  var {
    address,
    categories = [],
    id,
    statusCode,
    subTypeCode,
    typeCode
  } = listing;
  var slug = getTypeSlug(statusCode, typeCode, subTypeCode || null);
  var category = categories[0] ? categories[0].category : 'uncategorised';
  var {
    country,
    postCode,
    state,
    stateCode,
    suburb
  } = address;
  var url = (0, _map.default)(_context7 = ['properties', slug, stateCode || state || country, (0, _filter.default)(_context8 = [suburb, postCode]).call(_context8, x => x).join('-'), category, id]).call(_context7, _string.toSlug).join('/');
  return "/".concat(url);
}
function combinePaths(crumbs) {
  return (0, _reduce.default)(crumbs).call(crumbs, (result, _ref) => {
    var {
      part,
      path
    } = _ref;
    var prev = result[result.length - 1] || {};
    result.push({
      part,
      path: [prev.path || '', path].join('/')
    });
    return result;
  }, []);
}
function getQueryBreadcrumbs(params) {
  var _context9, _context10, _context11;
  var {
    category,
    postCode,
    region,
    status,
    subType,
    suburb,
    type
  } = params;
  var typeSlug = getTypeSlug(status, type, subType);
  var parts = (0, _filter.default)(_context9 = [{
    part: 'All Properties',
    path: 'properties'
  }, typeSlug && {
    part: (0, _string.unSlug)(typeSlug, {
      recase: true
    }),
    path: typeSlug
  }, region && {
    part: region.toUpperCase(),
    path: (0, _string.toSlug)(region)
  }, suburb && {
    part: (0, _concat.default)(_context10 = "".concat((0, _string.unSlug)(suburb, {
      recase: true
    }), " ")).call(_context10, postCode),
    path: (0, _concat.default)(_context11 = "".concat((0, _string.toSlug)(suburb), "-")).call(_context11, postCode)
  }, category && {
    part: (0, _string.unSlug)(category, {
      recase: true
    }),
    path: category
  }]).call(_context9, x => !!x);
  return combinePaths(parts);
}
function getListingBreadcrumbs(listing) {
  var _context12, _context13;
  var {
    address,
    categories = [],
    statusCode,
    subTypeCode,
    typeCode
  } = listing;
  var typeSlug = getTypeSlug(statusCode, typeCode, subTypeCode || null);
  var categoryCode = categories[0] ? categories[0].code : null;
  var categoryName = categories[0] ? categories[0].category : null;
  var {
    postCode,
    state,
    stateCode,
    suburb
  } = address;
  var parts = [{
    part: 'All Properties',
    path: 'properties'
  }, {
    part: (0, _string.unSlug)(typeSlug, {
      recase: true
    }),
    path: typeSlug
  }, stateCode ? {
    part: stateCode.toUpperCase(),
    path: (0, _string.toSlug)(stateCode)
  } : {
    part: state,
    path: (0, _string.toSlug)(state)
  }, {
    part: (0, _concat.default)(_context12 = "".concat(suburb, " ")).call(_context12, postCode),
    path: (0, _concat.default)(_context13 = "".concat((0, _string.toSlug)(suburb), "-")).call(_context13, postCode)
  }, {
    part: categoryName,
    path: (0, _string.toSlug)(categoryCode)
  }];
  return combinePaths(parts);
}

// TODO: handle country automatically based on office
// -- or ignore it and use multiple values, one for each country, when searching cats?
// Converts information and params form URL into a query object
function prepareQuery(params) {
  var {
    category,
    region,
    suburbPostcode,
    typeSlug
  } = params;
  var {
    postCode,
    suburb
  } = extractSuburbParts(suburbPostcode);
  var {
    custom = {},
    isValid,
    notSubTypeCode,
    statusCode,
    subTypeCode,
    typeCode
  } = extractTypeSlug(typeSlug);
  var query = {
    isValid,
    params: {
      ...custom,
      statusCode: statusCode || undefined,
      typeCode: typeCode || undefined,
      stateCode: (0, _string.unSlug)(region),
      suburb: (0, _string.unSlug)(suburb),
      postCode: postCode || undefined,
      categoryCode: category
    }
  };
  if (subTypeCode || notSubTypeCode) {
    query.params.subTypeCode = {};
    if (subTypeCode) query.params.subTypeCode.in = subTypeCode;
    if (notSubTypeCode) query.params.subTypeCode.not = notSubTypeCode;
  }
  return query;
}
function combineCategories(categories) {
  var {
    append = false
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return (0, _map.default)(categories).call(categories, _ref2 => {
    var _context14;
    var {
      category,
      subCategory
    } = _ref2;
    if (!append) return subCategory || category;
    return subCategory && subCategory !== category ? (0, _concat.default)(_context14 = "".concat(subCategory, " ")).call(_context14, category) : category;
  }).join('/');
}

/**
 * Describe the type of a listing, e.g Apartment for Sale,
 * Office for Sale or Lease.
 */
function describeListing(listing) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var {
    address: {
      suburb
    },
    categories: rawCategories = [],
    statusCode,
    subTypeCode,
    typeCode
  } = listing;
  var {
    onlyFirstCategory = true,
    withLocality = true,
    withStatus = false,
    withTypeSuffix = true
  } = options;
  var isBusiness = typeCode === 'BUS';

  // Drop "Other" category, as it's not meaningful as a descriptor
  var _categories = (0, _filter.default)(rawCategories).call(rawCategories, category => category.category !== 'Other' && category.subCategory !== 'Other');
  var categories = onlyFirstCategory ? (0, _slice.default)(_categories).call(_categories, 0, 1) : _categories;
  var hasCategories = categories.length;
  var parts = [];

  // Prefix with status (e.g. sold, leased, etc) if requested
  if (withStatus) parts.push((0, _codes.describeStatus)(statusCode));

  /* Rural categories, by themselves aren't clear enough, so we need to prefix
   * them with "Rural" or similar so that they make sense.  Rural categories
   * are things like "Cattle" and without the prefix it would not make sense.
   */
  if (typeCode === 'RUR' && hasCategories) parts.push((0, _codes.describeType)(typeCode));

  /* Use the categories to describe the listing if it has any, otherwise use
   * a generic description based on the type of listing.
   *
   * The categories aren't relevant for a holiday rental so we ignore them and
   * always use the type code description.
   */
  var label = typeCode === 'HOL' ? (0, _codes.describeType)(typeCode) : combineCategories(categories, {
    append: isBusiness
  }) || (0, _codes.describeType)(typeCode);
  parts.push(label);

  /* Business categories also need an extra suffix because they're not clear enough
   * by themselves.
   */
  var appendType = hasCategories && isBusiness;
  if (appendType) parts.push((0, _codes.describeType)(typeCode));

  /**
   * Rural categories may also not clearly indicate that it's a property, e.g.
   * it might just say "Livestock", so we need to clarify that this is a property
   * in that case.  Some do, so we don't always need to do this!
   */
  if (typeCode === 'RUR' && !/ property$/i.test(label)) parts.push('Property');

  /* Callers may choose to omit the type suffix, but LVW (livestock wanted)
   * always needs to have it added when using the categories in order to avoid
   * ambiguity.  LVW categories are like "Cattle", so this changes that to
   * "Cattle Wanted".  Clearing Sales *without* categories already indicate that
   * it's a sale, so must exclude the "for sale" suffix.
   */
  if ((withTypeSuffix || typeCode === 'LVW' && categories.length) && !(typeCode === 'CLR' && !hasCategories) && !(statusCode === 'CUR' && typeCode === 'HOL')) {
    /* Commercial type listings (commercial, business and commercial land) have
     * a subtype which indicates whether they're for sale, for lease or both.
     */
    parts.push(subTypeCode ? (0, _codes.describeSubTypeStatus)(subTypeCode, statusCode) : (0, _codes.describeTypeStatus)(typeCode, statusCode));
  }

  // Say where the listing is if asked and we have the suburb data available
  if (withLocality && suburb) parts.push("in ".concat(suburb));

  // Drop any falsy (empty, undefined) values and join the rest together
  return (0, _filter.default)(parts).call(parts, Boolean).join(' ');
}
var addressOptions = {
  withLocality: true,
  withState: true,
  withPostCode: true
};
var descriptionOptions = {
  withStatus: true,
  withLocality: false
};
function createPageTitle(listing, language) {
  var _context15, _context16;
  var addressString = (0, _formatting.stringifyAddress)(listing.address, addressOptions);
  var description = describeListing(listing, descriptionOptions);
  return (0, _concat.default)(_context15 = (0, _concat.default)(_context16 = "".concat(addressString, " - ")).call(_context16, language === 'zh-Hans' ? '中文 - ' : '')).call(_context15, description);
}

/**
 * Determine whether the listing has any valid members to show; a member is valid
 * if they're not yet loaded (may change when loaded) or if they're loaded and
 * have a minimal set of data.
 *
 * @param Array members The list of members to check.
 * @return Boolean
 */
var hasValidMembers = members => !!members.length && !!(0, _filter.default)(members).call(members, member => !member.loaded || (0, _agent.hasMinimalInfo)(member)).length;

/**
 * TODO: We should really be doing a better job of finding an acceptable
 * image to use as a header image... the function below only takes into
 * account whether or not an image meets a given minimum width, we should
 * also be looking for the largest (most expensive etc) image.
 */
exports.hasValidMembers = hasValidMembers;
var getStructuredData = (listing, office, baseUrl, language) => {
  var _context17, _context18, _context19, _context34, _context35, _context36;
  var {
    address,
    address: {
      country,
      location,
      postCode,
      state,
      stateCode,
      suburb
    },
    auction,
    availableDate,
    images,
    inspections = [],
    soldDate,
    statusCode,
    translations,
    typeCode
  } = listing;
  var {
    title = ''
  } = translations[language] || {
    title: listing.title
  };
  var isResidence = typeCode === 'SAL' || typeCode === 'RES';
  var url = baseUrl && (0, _concat.default)(_context17 = "".concat(baseUrl)).call(_context17, getListingUrl(listing));
  var {
    date: soldDom,
    month: soldMonth,
    year: soldYear
  } = soldDate ? (0, _time.createTime)(soldDate) : {};
  var soldDesc = soldDate ? (0, _concat.default)(_context18 = (0, _concat.default)(_context19 = "on ".concat(soldDom, " ")).call(_context19, soldMonth, " ")).call(_context18, soldYear, " ") : '';
  var streetAddress = (0, _formatting.stringifyAddress)(address);
  var fullAddress = (0, _formatting.stringifyAddress)(listing.address, {
    withLocality: true,
    withState: true,
    withPostCode: true
  });
  var image = images[0] && "".concat(images[0].url, "?maxwidth=1280");
  var events = [];
  if (auction) {
    var _context20, _context21, _context22, _context23, _context24, _context25;
    var {
      date,
      day,
      meridiem,
      month,
      time
    } = (0, _time.createTime)(auction.date);
    var eventTime = (0, _concat.default)(_context20 = (0, _concat.default)(_context21 = (0, _concat.default)(_context22 = (0, _concat.default)(_context23 = "".concat(day, " ")).call(_context23, date, " ")).call(_context22, month, ", ")).call(_context21, time)).call(_context20, meridiem);
    var auctionLocation = auction.location && !/^on[ -]site$/i.test(auction.location) ? auction.location : undefined;
    var eventLocation = (0, _structuredData.place)({
      address: auctionLocation || fullAddress,
      name: (0, _concat.default)(_context24 = "Auction ".concat(time)).call(_context24, meridiem)
    }, !auctionLocation && isResidence);
    events.push({
      name: 'Auction',
      description: auctionLocation ? (0, _concat.default)(_context25 = "Auction ".concat(eventTime, ", ")).call(_context25, auction.location) : "Auction on site at ".concat(eventTime),
      image,
      startDate: auction.date,
      doorTime: auction.date,
      location: eventLocation,
      url
    });
  }
  if (availableDate) {
    var _context26, _context27;
    var {
      date: _date,
      day: _day,
      month: _month
    } = (0, _time.createTime)(availableDate);
    events.push({
      name: 'Available',
      description: (0, _concat.default)(_context26 = (0, _concat.default)(_context27 = "Available from ".concat(_day, " ")).call(_context27, _date, " ")).call(_context26, _month),
      image,
      startDate: availableDate,
      location: (0, _structuredData.place)({
        address: fullAddress
      }, isResidence),
      url
    });
  }
  events.push(...(0, _map.default)(inspections).call(inspections, _ref3 => {
    var _context28, _context29, _context30, _context31, _context32, _context33;
    var {
      finish,
      start
    } = _ref3;
    var {
      date,
      day,
      end: {
        meridiem: _fm,
        time: _f
      },
      month,
      start: {
        meridiem: _sm,
        time: _s
      }
    } = (0, _time.createTimeRange)(start, finish);
    var time = (0, _concat.default)(_context28 = (0, _concat.default)(_context29 = (0, _concat.default)(_context30 = "".concat(_s)).call(_context30, _sm === _fm ? '' : _sm, " - ")).call(_context29, _f)).call(_context28, _fm);
    var eventTime = (0, _concat.default)(_context31 = (0, _concat.default)(_context32 = (0, _concat.default)(_context33 = "".concat(time, " ")).call(_context33, day, " ")).call(_context32, date, " ")).call(_context31, month);
    return {
      name: 'Inspection',
      description: "Inspection ".concat(eventTime),
      image,
      startDate: start,
      endDate: finish,
      location: (0, _structuredData.place)({
        name: "Inspection ".concat(time),
        address: fullAddress
      }, isResidence),
      url
    };
  }));
  var fullName = (0, _filter.default)(_context34 = [describeListing(listing, {
    withLocality: false,
    withStatus: true
  }), fullAddress]).call(_context34, x => !!x).join(' - ');
  var fullDescription = (0, _filter.default)(_context35 = ["'".concat(title.replace(/\.\+$/, ''), "'"), statusCode === 'CUR' && office && "Listed by ".concat(office.fullName), statusCode === 'SLD' && office && (0, _concat.default)(_context36 = "Sold ".concat(soldDesc, "by ")).call(_context36, office.fullName), statusCode === 'LSE' && office && "Leased by ".concat(office.fullName)]).call(_context35, x => !!x).join(' - ');
  return (0, _structuredData.place)({
    id: "https://raywhite.com/".concat(listing.id),
    url,
    name: fullName,
    description: (0, _sanitization.plainText)(fullDescription),
    image,
    geo: location && (0, _structuredData.geoCoordinates)({
      latitude: location.lat,
      longitude: location.lon
    }),
    address: (0, _structuredData.postalAddress)({
      name: streetAddress,
      streetAddress,
      postalCode: postCode,
      addressCountry: country,
      addressRegion: stateCode || state,
      addressLocality: suburb
    }),
    event: events.length ? (0, _map.default)(events).call(events, _structuredData.event) : undefined
  }, isResidence);
};
exports.getStructuredData = getStructuredData;
function listingLinkMeta(listing) {
  return (0, _link.eventMeta)({
    category: 'Listing',
    action: 'View',
    label: (0, _formatting.stringifyAddress)(listing.address, {
      withLocality: true,
      withState: true,
      withPostCode: true
    })
  });
}
var replaceDimensions = (_, dimensions) => "".concat(dimensions, "m\xB2");
var replaceExtraSpace = (_, word, punc) => {
  var _context37;
  return (0, _concat.default)(_context37 = "".concat(word)).call(_context37, punc);
};
var addMissingSpace = (_, punc, word) => {
  var _context38;
  return (0, _concat.default)(_context38 = "".concat(punc, " ")).call(_context38, word);
};
var fixInconsistentHyphens = (_, a, b) => a ? "".concat(a, " - ") : " - ".concat(b);

/**
 * Sanitisation function to make some of the more crazy listing titles a
 * little less so.
 */
var cleanTitle = title => title && title
// Replace multiple exclamation marks with one
.replace(/!{2,}/g, '!')
// Replace 3+ periods with an ellipsis
.replace(/\.{3,}/g, '…')
// Replace square metre dimensions with m²
.replace(/([\d,]+)\s*(m2|sqm)\b/gi, replaceDimensions)
// Replace multiple spaces with one
.replace(/\s{2,}/g, ' ')
// Remove extra space between words and punctuation
.replace(/(\w)\s([,!.?])/g, replaceExtraSpace)
// Add space where missing between words and punctuation
.replace(/([,!.…])([a-zA-Z])/, addMissingSpace)
// Correct inconsistent hypenation
.replace(/(?:([a-zA-Z0-9])-\s|\s-([a-zA-Z0-9]))/, fixInconsistentHyphens);

/**
 * Filter listing to ensure that it may be shown.  Generally listings may
 * only be shown if they belong to the site organisations, but SLD and LSE
 * status listings may possibly be shown if they belong to an agent that belongs
 * to the site organisations and the site has chosen to allow them to be shown.
 */
exports.cleanTitle = cleanTitle;
async function filterListing(listing, organisationIds, agentShowTransactions, getMembers) {
  var _context39, _context40, _context41;
  // Missing listing
  if (!listing) return listing;

  // Listing matches orgs, show it
  if (~(0, _indexOf.default)(organisationIds).call(organisationIds, listing.office.organisationId)) return listing;

  // Listing is current, so must match orgs or not be shown
  if (listing.statusCode === 'CUR') return undefined;
  var memberIds = (0, _filter.default)(_context39 = (0, _map.default)(_context40 = listing.agents || []).call(_context40, _ref4 => {
    var {
      memberId
    } = _ref4;
    return memberId;
  })).call(_context39, x => x);

  // Organisation does not match site orgs and there are no agents or we may
  // not show transactions for other offices even if agents match, abort early
  if (agentShowTransactions !== 'any' || !memberIds.length) return undefined;

  // Permitted to show any listings where agents match, so compare the agent(s)
  var {
    results: members
  } = await getMembers({
    id: memberIds
  });
  var memberOrgIds = (0, _concat.default)(_context41 = []).call(_context41, ...(0, _map.default)(members).call(members, _ref5 => {
    var {
      organisationIds: oIds
    } = _ref5;
    return oIds;
  }));
  var matched = (0, _reduce.default)(memberOrgIds).call(memberOrgIds, (result, orgId) => {
    if (result) return result;
    return !!~(0, _indexOf.default)(organisationIds).call(organisationIds, orgId);
  }, false);
  return matched ? listing : undefined;
}
function getDisclaimers(listing, hasInformationMemorandum) {
  var _context42;
  var {
    address: {
      stateCode
    },
    attachments,
    auction,
    displayPrice,
    statusCode,
    subTypeCode,
    typeCode
  } = listing;
  var disclaimers = [];

  // Investment Disclaimers should still show up because the data is still displayed
  if (statusCode !== 'CUR') return disclaimers;
  if (attachments.length > 0 && !hasInformationMemorandum) {
    disclaimers.push("All information about the property has been provided to\n      Ray White by third parties. Ray White has not verified the information and does\n      not warrant its accuracy or completeness. Parties should make and rely on their\n      own enquiries in relation to the property.");
  }
  switch (stateCode) {
    case 'VIC':
      if (isSellable(typeCode, subTypeCode)) {
        disclaimers.push("\n          <a\n            target=\"_blank\"\n            rel=\"noopener noreferrer\"\n            href=\"https://www.consumer.vic.gov.au/duediligencechecklist\"\n          >\n            Due diligence checklist\n          </a>\n          for home and residential property buyers\n        ");
      }
      if ((0, _indexOf.default)(_context42 = ['RUR']).call(_context42, typeCode) !== -1) {
        disclaimers.push("\n         This property may require the\n          <a\n            target=\"_blank\"\n            rel=\"noopener noreferrer\"\n            href=\"https://www.consumer.vic.gov.au/resources-and-education/legislation/public-consultations-and-reviews/review-of-section-32-of-the-sale-of-land-act-1962#current-disclosure-requirements\"\n          >\n          disclosure of certain information\n          </a>\n          to prospective purchasers.\n        ");
      }
      break;
    case 'QLD':
      // Sellable and for auction or has non-price-ish price
      if (isSellable(typeCode, subTypeCode) && (auction || (displayPrice || '').match(/[^$ 0-9,]/))) {
        disclaimers.push('This property is being sold by auction or without a price and therefore a price guide can not be provided. The website may have filtered the property into a price bracket for website functionality purposes.');
      }
      break;
    default:
    // No disclaimers
  }
  return disclaimers;
}
function isElite(_ref6) {
  var {
    eliteExpiry,
    eliteStart
  } = _ref6;
  // No start, can't be elite
  if (!eliteStart) return false;
  var now = new Date().getTime();
  var start = new Date(eliteStart).getTime();

  // Not yet started, not elite
  if (now < start) return false;

  // Has started and no end, must be elite
  if (!eliteExpiry) return true;
  var stop = new Date(eliteExpiry).getTime();

  // Elite if not yet at the stop point
  return now < stop;
}

/**
 * Get a text description of a search.
 */
function describeSearch(params) {
  var _context43, _context44, _context45;
  var {
    plural = false,
    typed = false
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var {
    status: _status,
    type: _type
  } = params;

  // Too complicated to describe
  if ((0, _isArray.default)(_status) && _status.length !== 1 || (0, _isArray.default)(_type) && _type.length !== 1) {
    return 'properties';
  }
  var status = (0, _isArray.default)(_status) ? _status[0] : _status;
  var type = (0, _isArray.default)(_type) ? _type[0] : _type;
  var properties = (0, _utils.pluralize)(plural ? 2 : 1, 'property', 'properties');
  var typeDesc = (0, _codes.describeTypeNouns)(type, true);
  switch (status) {
    case 'SLD':
      return (0, _concat.default)(_context43 = "Sold ".concat(typed ? typeDesc.toLowerCase() : '', " ")).call(_context43, properties);
    case 'LSE':
      return (0, _concat.default)(_context44 = "Leased ".concat(typed ? typeDesc.toLowerCase() : '', " ")).call(_context44, properties);
    case 'CUR':
      // Continued below based on type
      break;
    default:
      return properties;
  }
  var suffix = (0, _codes.describeTypeStatus)(type, status);
  return (0, _concat.default)(_context45 = "".concat(typeDesc, " ")).call(_context45, suffix.toLowerCase());
}
var listingsToPoints = listings => {
  if (!listings) return [];
  return (0, _reduce.default)(listings).call(listings, (result, listing) => {
    var {
      address: {
        location: {
          lat,
          lon
        } = {}
      }
    } = listing;
    if (!(lon && lat)) {
      return result;
    }
    result.push({
      lat,
      lng: lon,
      data: [listing]
    });
    return result;
  }, []);
};
exports.listingsToPoints = listingsToPoints;